/* import __COLOCATED_TEMPLATE__ from './conversation-rating-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();